import { styled } from 'goober';
import { Container, ImageForSlides } from './slideOne';
import { Points, PointsContainer, StepsTextContainer } from './slideTwo';

const WhatItIsText = styled('div')`
  padding-top: 24px;
  font-size: 25px;
  font-weight: 500;
  line-height: 38px;
  font-style: normal;
  color: #949494;
  margin-top: 0;
  @media only screen and (max-width: 600px) {
    font-size: 20px;
    width: 100%;
  }
`;

const TitleText = styled('div')`
  width: 353px;
  margin-bottom: 20px;
  font-style: normal;
  font-size: 30px;
  font-weight: 600;
  line-height: 35px;
  margin-top: 20px;
  color: #00733b;
  @media only screen and (max-width: 600px) {
    margin-top: 10px;
    margin-bottom: 10px;
    font-size: 16px;
    width: 90%;
    line-height: 22px;
  }
`;

const StepsText = styled('p')`
  height: fit-content;
  font-weight: 400;
  font-size: 18px;
  line-height: 22px;
  color: #04581b;
  width: ${(props) => (props.stepsCount === 2 ? '54%' : '100%')};
  @media only screen and (max-width: 600px) {
    width: 153px;
    font-size: 12px;
    line-height: 14px;
  }
`;
const ImageContainerForSlides = styled('div')`
  margin-top: 4px;
  position: absolute;
  bottom: 0;
  right: 0;
  width: 248px;
  height: 270px;
  @media only screen and (min-height: 360px) and (max-width: 600px) {
    width: 43%;
    height: 33vw;
  }
  @media only screen and (min-height: 320px) and (max-width: 359px) {
    width: 44%;
    height: 33vw;
  }
`;

const SlideFour = () => {
  return (
    <Container>
      <WhatItIsText> How to repay?</WhatItIsText>
      <TitleText>Never miss your EMI repayment</TitleText>
      <StepsTextContainer>
        <PointsContainer>
          <Points>1</Points>
        </PointsContainer>
        <StepsText stepsCount={1}>
          Auto re-payment from your bank account. EMI will be auto-debited as
          per your Mandate
        </StepsText>
      </StepsTextContainer>

      <StepsTextContainer>
        <PointsContainer>
          <Points>2</Points>
        </PointsContainer>
        <StepsText stepsCount={2}>
          Track your transaction history on InstaCred dashboard
        </StepsText>
      </StepsTextContainer>
      <ImageContainerForSlides>
        <ImageForSlides
          style={{
            backgroundImage:
              "url('https://iccdn.in/img/edu_modal_hero_image2.png')",
          }}
        />
      </ImageContainerForSlides>
    </Container>
  );
};

export default SlideFour;



// WEBPACK FOOTER //
// ./componentsBICRevamp/buyWithInstacredLanding/educationalModal/slideFour.js